import { render, staticRenderFns } from "./PropertyColombo.vue?vue&type=template&id=58df8482&scoped=true&"
import script from "./PropertyColombo.vue?vue&type=script&lang=js&"
export * from "./PropertyColombo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58df8482",
  null
  
)

export default component.exports